/* eslint-disable no-useless-escape */
export const ONLY_NUMBER_REG_EXP = /^[0-9]*$/
export const DECIMAL_NUMBER_REG_EXP = /^[0-9]\d*(\.\d+)?$/
export const NEW_PASSWORD_REG_EXP = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,20}$/
export const PASSWORD_REG_EXP = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9])[A-Za-z\d\W]{8,}$/
export const EMAIL_REG_EXP =
  /^\s*(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))\s*$/
export const UK_POSTCODE_REG_EXP = /^[A-Za-z]{1,2}\d[A-Za-z\d]?\s*\d[A-Za-z]{2}$/
export const UK_NUMBER_REG_EXP = /^(?:(?:\+?44\s?(?:\d\s?){8,10})|\b(?:(?:0(?=[23456789])|(?:[1-9])(?=[23456789]))(?:[\d\s]){8,10})\b)$/

export const SITE_NAME = 'Azitech'
export const REACT_APP_ENV = process.env.REACT_APP_ENV || 'production'
export const DOMAIN = process.env.REACT_APP_DOMAIN || 'http://clubmatch-user.s3-website-eu-west-1.amazonaws.com'
export const S3_PREFIX = process.env.REACT_APP_S3_PREFIX || 'https://azitech-stackup.s3.ap-south-1.amazonaws.com'
export const API_URL = process.env.REACT_APP_API_URL || 'https://azitech-backend-stag.lc.webdevprojects.cloud/api/'
export const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || 'wss://azitech-backend-stag.lc.webdevprojects.cloud/'
export const EXCEL_LINK = `${S3_PREFIX}/latest_formate.xlsx`
export const ONESIGNAL_APP_ID = 'f3c646ec-bd1c-46c1-81a2-3a9b4e502862'

export const MATERIAL_COLOR = {
  sm: 'bg-board-soldermask',
  cp: 'bg-board-copper',
  p: 'bg-board-prepreg',
  pl: 'bg-board-plated',
  co: 'bg-board-core'
}
export const LAYER_STACK = {
  sm: 'Soldermask',
  cp: 'Copper',
  p: 'Prepreg',
  pl: 'Plated Copper',
  co: 'Core'
}
export const LIBRARY_TYPE = {
  p: { label: 'Prepreg', value: 'p' },
  cp: { label: 'Copper', value: 'cp' },
  sm: { label: 'Solder Mask', value: 'sm' },
  co: { label: 'Core', value: 'co' }
}
export const STATUS = {
  p: { label: 'Pending', value: 'p' },
  a: { label: 'Approve', value: 'a' },
  r: { label: 'Reject', value: 'r' },
  d: { label: 'Deleted', value: 'd' },
  dr: { label: 'Draft', value: 'dr' }
}
export const FREQUENCY = {
  '1MHz': { label: '1MHz', value: '1MHz' },
  '1GHz': { label: '1GHz', value: '1GHz' },
  '2GHz': { label: '2GHz', value: '2GHz' },
  '5GHz': { label: '5GHz', value: '5GHz' },
  '10GHz': { label: '10GHz', value: '10GHz' }
}
export const BOARD_TYPE = {
  rp: { label: 'Rigid', value: 'rp' },
  fp: { label: 'Flex', value: 'fp' },
  rfp: { label: 'Rigid Flex', value: 'rfp' }
}
export const STACK_UP_STATUS = {
  d: 'Deleted',
  p: 'Pending',
  a: 'Approved',
  r: 'Rejected',
  dr: 'Draft'
}

export const PLATED_CLASS = {
  cl1: { label: '+18', value: 18 },
  cl2: { label: '+25', value: 25 }
}

export const PAD_SIZE = {
  MIV: [250],
  MECH: [400],
  PTH: [550]
}
export const HOLE_SIZE = {
  MIV: [100],
  MECH: [150],
  PTH: [300]
}

export const SCREEN_TITLE = {
  1: 'Forgot Password',
  2: 'OTP',
  3: 'Reset Password'
}

export const SCREEN_SUBTITLE = {
  1: 'Please enter your email to Forgot Password.',
  2: 'Please check your email and enter the OTP to continue.',
  3: 'Enter new password and confirm password to complete the forgot process.'
}
